import { render, staticRenderFns } from "./detail_card.vue?vue&type=template&id=c09124a0&scoped=true&"
var script = {}
import style0 from "./detail_card.vue?vue&type=style&index=0&id=c09124a0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09124a0",
  null
  
)

export default component.exports